import { MovementDataRenderer } from '@features/gateCommon';
import { Trans } from '@lingui/macro';
import { Box, Skeleton, Slide, Typography } from '@mui/material';
import { type FC, useRef } from 'react';
import { TransitionGroup } from 'react-transition-group';
import { PanelPaper } from './common';
import { NotificationCard } from './panelNotification/NotificationCard';

interface Props {
  movementId: string | null;
}

export const PanelNotifications: FC<Props> = ({ movementId }) => {
  const containerRef = useRef<HTMLElement>(null);
  return (
    <PanelPaper
      sx={{
        gridArea: 'notif',
        flexGrow: 1,
        py: 2,
        pb: 0,
        color: 'white',
        borderRadius: 1,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box sx={{ mb: 1, px: 1 }}>
        <Typography variant="h6" fontWeight="bold">
          <Trans>Operación en tiempo real</Trans>
        </Typography>
      </Box>

      <Box
        className="custom-scrollbar"
        sx={{
          gap: 3 / 4,
          overflowY: 'auto',
          overflowX: 'clip',
          pb: 2,
        }}
      >
        {movementId ? (
          <MovementDataRenderer
            movementId={movementId}
            render={({ movement }) => {
              const messages = movement.messages;
              if (messages.length === 0) {
                return (
                  <Typography color="text.secondary" p={2} fontStyle="italic">
                    <Trans>Aún no se han recibido mensajes de la compuerta</Trans>
                  </Typography>
                );
              }
              return (
                <TransitionGroup>
                  {messages.map((notification, index) => (
                    <Slide direction="left" key={notification.id} ref={containerRef}>
                      <Box my={1}>
                        <NotificationCard
                          key={notification.id}
                          data={notification}
                          isFeatured={index === 0}
                        />
                      </Box>
                    </Slide>
                  ))}
                </TransitionGroup>
              );
            }}
            fallback={() => <Skeleton />}
          />
        ) : (
          <Typography color="text.secondary" p={2} fontStyle="italic">
            <Trans>Aún no se han recibido mensajes de la compuerta</Trans>
          </Typography>
        )}
      </Box>
    </PanelPaper>
  );
};
